import ReactDOM from 'react-dom/client';
import App from './app.tsx';
import { createTheme, ThemeProvider } from '@mui/material';
import AuthGate from './shared/utils/auth/AuthGate.tsx';
import { registerDevtools } from './devtools/devtools.ts';

if (import.meta.env.DEV) {
  registerDevtools();
}

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(132, 90, 223)",
      contrastText: "#fff"
    }
  }
})

const Root = () => (
  <AuthGate>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </AuthGate>
)

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
